import React from 'react';
import { useHistory } from 'react-router-dom';

import { v4 as uuidv4 } from 'uuid';
import Drawer from '@material-ui/core/Drawer';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import BaseIcon from '@material-ui/core/Icon';
import MapIcon from '@material-ui/icons/Map';
import SearchIcon from '@material-ui/icons/Search';
import { AiOutlineLineChart } from 'react-icons/ai';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import clickHemofiliaLogo from '~/assets/clickhemofilia-logo-registered.png';

import { Container, ListItem } from './styles';

const drawerWidth = 300;

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerContainer: {
    overflow: 'auto',
    marginTop: 30,
  },
}));

const routes = [
  {
    icon: <SearchIcon />,
    routename: 'Buscar pacientes',
    pathname: '/search',
    id: uuidv4(),
  },
  {
    icon: <BaseIcon className="icon-infusion" />,
    routename: 'Reg. de medicamento',
    pathname: '/drug',
    id: uuidv4(),
  },
  {
    icon: <AiOutlineLineChart />,
    routename: 'Emitir relatórios',
    pathname: '/reports',
    id: uuidv4(),
  },
  { icon: <MapIcon />, routename: 'Mapas', pathname: '/maps', id: uuidv4() },
];

function ClippedDrawer() {
  const classes = useStyles();
  const history = useHistory();

  const { location } = history;

  function handleClick(page) {
    history.push(page);
  }

  return (
    <Container>
      <Drawer
        className={classes.drawer}
        variant="permanent"
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <Toolbar />
        <div className={classes.drawerContainer}>
          <Typography className="navigation-text">Navegação</Typography>

          <List>
            {routes.map(({ id, icon, routename, pathname }) => {
              return (
                <ListItem
                  button
                  onClick={() => handleClick(pathname)}
                  selected={location.pathname.includes(pathname)}
                  key={id}
                >
                  <ListItemIcon>{icon}</ListItemIcon>
                  <ListItemText primary={routename} />
                </ListItem>
              );
            })}
          </List>
        </div>

        <img id="clickhemofilia-logo" src={clickHemofiliaLogo} alt="clickhemofilia-logo" />
      </Drawer>
    </Container>
  );
}

export default ClippedDrawer;
